module.exports = __webpack_public_path__ + "static/media/aboutUs1.e736fb42.png";